import { render } from "./RenderTest.vue?vue&type=template&id=0dc840e4&scoped=true"
import script from "./RenderTest.vue?vue&type=script&lang=js"
export * from "./RenderTest.vue?vue&type=script&lang=js"

import "./RenderTest.vue?vue&type=style&index=0&id=0dc840e4&scoped=true&lang=css"
import "./RenderTest.vue?vue&type=style&index=1&id=0dc840e4&lang=css"

import exportComponent from "E:\\Dev\\Univ\\vueQuizzly\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0dc840e4"]])

export default __exports__